import { workOrderChargeCostSchema } from '../work-order/work-order-charge-cost-schema.js';
export const bomChargeCostSchema = workOrderChargeCostSchema.nullish();
//# sourceMappingURL=bom-charge-cost-schema.js.map